import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { motion } from 'framer-motion'
import {
    Container,
    Heading,
    Box,
    Flex,
    Text,
    Collapse,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    useDisclosure,
    ModalBody,
    ModalCloseButton
} from '@chakra-ui/react';
import { PrismicRichText } from "@prismicio/react"


function BioModal(props) {
    const { isOpen, onOpen, onClose } = useDisclosure()
  
    return (
      <>
        <Box p="4" w={{base: '100%', md: '50%', lg: '33.33%'}} onClick={onOpen} as={motion.div}
            layout 
            initial={{opacity: 0}}
            animate={{ opacity: 1}}
            exit={{ opacity: 0}}    
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            cursor="pointer"
            bg="white"
        >
        <Flex flexDirection="column" justifyContent="flex-start" w="100%" h="100%" 
            border="1px solid" borderColor="gray.200" borderRadius="xl"
            boxShadow="lg"
            >
                <Box bg="sage.500" p="4" borderTopRadius="xl">
                    <Heading as="h3" size="md" fontWeight="bold" color="white">
                        {props.directorName}
                    </Heading>
                    <Text mb="0" color="white" size="sm">
                        {props.directorPosition}
                    </Text>
                </Box>
                <Box borderBottomRadius="xl" flex="1"  bg="white">
                    <GatsbyImage image={getImage(props.directorPhoto)} alt={props.directorPhotoAlt} imgStyle={{borderBottomLeftRadius: '1rem', borderBottomRightRadius: '1rem'}}/>
                </Box>
                </Flex>
        </Box>
  
        <Modal size="xl" blockScrollOnMount={false} isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent borderRadius="xl">
            <ModalHeader p="8">{props.directorName}
            <Text fontWeight='bold' mb="0">
                {props.directorPosition}
              </Text></ModalHeader>
            <ModalCloseButton m="4"/>
            <ModalBody>
              <Box px="2">
                  
                  <PrismicRichText field={props.directorBio} />
                  
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    )
  }

export default function Bios({ slice }) {
    const [show, setShow] = React.useState(false);
    const handleToggle = () => setShow(!show);

    return (
        <Container maxW="container.xl">
            <Heading as="h2" variant="h2" my="12" textAlign="center">
                {slice.primary.section_title.text}
            </Heading>
            <Box my="12">
                <Flex flexWrap="wrap" justifyContent="center">
                    {slice.items.map((item, index) => (
                        <BioModal key={index} 
                            directorName={item.name}
                            directorPosition={item.title}
                            directorBio={item.bio.richText}
                            directorPhoto={item.photo.localFile}
                            directorPhotoAlt={item.photo.alt}
                        />
                    ))}
                </Flex>
            </Box>
        </Container>
    )
}